import Api from './api';

const vesselListRequest = () => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/vessels', {
        headers: { Authorization: 'Bearer ' + access_token } ,
    })
}

const createVesselRequest = (data) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().post('/api/vessels/', data, { headers: { Authorization: 'Bearer ' + access_token } })
}

const deleteVesselRequest = (id) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().delete('/api/vessels/' + id, { headers:
        {
            Authorization: 'Bearer ' + access_token,
            'Content-Type': 'application/x-www-form-urlencoded'
        }

    })
}


export default { vesselListRequest, createVesselRequest, deleteVesselRequest }



// WEBPACK FOOTER //
// ./src/api/apiVessels.js